__turbopack_context__.v({
  "productPointsContent": "product-points-module-scss-module__J9vceG__productPointsContent",
  "productPointsImage": "product-points-module-scss-module__J9vceG__productPointsImage",
  "productPointsList": "product-points-module-scss-module__J9vceG__productPointsList",
  "productPointsListItem": "product-points-module-scss-module__J9vceG__productPointsListItem",
  "productPointsListItemContent": "product-points-module-scss-module__J9vceG__productPointsListItemContent",
  "productPointsListItemDescription": "product-points-module-scss-module__J9vceG__productPointsListItemDescription",
  "productPointsListItemTitle": "product-points-module-scss-module__J9vceG__productPointsListItemTitle",
  "productPointsSection": "product-points-module-scss-module__J9vceG__productPointsSection",
});
